/**
 * Gmailでメール件名を使って検索する
 * @param {string} subject メールの件名
 * @return {void}
 */
export const searchGmailBySubject = (subject: string): void => {
  // 件名をURLエンコードしてGmail検索用のクエリパラメータとして使用
  const encodedSubject = encodeURIComponent(subject);
  window.open(
    `https://mail.google.com/mail/u/0/#search/subject:${encodedSubject}`,
    "_blank",
    "noopener,noreferrer",
  );
};
